module.exports = __webpack_public_path__ + "img/bg-collage-join.2df26423.svg";